module.exports = __webpack_public_path__ + "img/avatar-bot.db54bafd.jpg";